export class Containertrnd {

    year: number;
    constructor(year: number)
    {
        this.year=year;
    }

}